import { Box, Button, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import EducationCard from "./_sections/educations/EducationCard";
import DialogBox from "components/lib-ui/DialogBox";
import EducationFormModal from "./_sections/educations/EducationFormModal";
import { CatButton } from "assets/styled-components/CatButton";

export default function EducationForm({ onSubmit }) {
    const { handleSubmit } = useForm();
    const [dialogOpen, setDialogOpen] = useState(false);

    const educationsFromAPI = useSelector(
        (state) => state.currentCandidateAI.educations,
    );
    const [educations, setEducations] = useState(educationsFromAPI?.data || []);
    const handleDialogClose = () => {
        setDialogOpen(false);
    };
    const onEducationSubmit = () => {
        onSubmit(educations);
    };
    return (
        <Stack
            onSubmit={handleSubmit(onEducationSubmit)}
            component="form"
            sx={{ position: "relative" }}
        >
            {educations.length === 0 && (
                <Box sx={{minHeight: '450px'}}>
                    <Typography sx={{ pb: 2 }}>No educations added yet.</Typography>
                </Box>
            )}

            {educations.length > 0 && (
                <Stack
                    spacing={2}
                    sx={{
                        width: "100%",
                        pb: 2,
                    }}
                >
                    {educations.map((data, index) => (
                        <EducationCard
                            key={index}
                            educationData={data}
                            setEducations={setEducations}
                        />
                    ))}
                </Stack>
            )}
            <Stack
                direction="row"
                spacing={2}
                sx={{
                    mt: 2,
                    position: "sticky",
                    bottom: "0",
                    right: "0",
                    zIndex: 10,
                    justifyContent: "space-between",
                    backgroundColor: "white",
                    margin: "0 -24px",
                    padding: "8px 16px",
                    boxShadow: "0 -2px 4px rgba(0,0,0,0.1)",
                    alignContent: "center",
                }}
            >
                <Button
                    sx={{ borderRadius: "50px", padding: "10px 30px" }}
                    size="medium"
                    color="primary"
                    variant="contained"
                    onClick={() => setDialogOpen(true)}
                >
                    Add Education
                </Button>
                <CatButton
                    type="submit"
                    size="medium"
                    variant="contained"
                    sx={{ width: "fit-content" }}
                >
                    Submit Educations
                </CatButton>
            </Stack>
            <DialogBox
                isDialogOpen={dialogOpen}
                setIsDialogOpen={setDialogOpen}
                title="Edit education"
                floatCancel={true}
                showActionButtons={false}
            >
                <EducationFormModal
                    isDialogOpen={dialogOpen}
                    setIsDialogOpen={setDialogOpen}
                    onSubmit={handleDialogClose}
                    setEducations={setEducations}
                />
            </DialogBox>
        </Stack>
    );
}
